export const base_url = process.env.REACT_APP_BASE_URL;
export const uploads_url = process.env.REACT_APP_UPLOADS_URL;
export const get_thumbnail = `${base_url}/getimage/`;
